var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100p h-100p",attrs:{"id":_vm.echartId}})
}
var staticRenderFns = []

export { render, staticRenderFns }